import Backbone from 'backbone';
import RenditionModel from './renditionModel';
export default Backbone.Model.extend({
    defaults: {},
    initialize(data) {
        const collection = Object.keys(data).reduce((col, key) => {
            if (this.get(key) instanceof RenditionModel) {
                this.get(key).set(data[key]);
            } else {
                col[key] = new RenditionModel(data[key]);
            }
            return col;
        }, {});
        this.set(collection);
        return this;
    },
    setParentDimensions(parent) {
        this.width = parent.width;
        this.height = parent.height;
        this.setChildDimensions(parent);
        return this;
    },
    setChildDimensions(parent) {
        Object.keys(this.toJSON()).forEach(key => this.get(key).setParentDimensions(parent));
        return this;
    },
    fixNulls() {
        Object.keys(this.toJSON()).forEach(key => this.get(key).fixNulls());
        return this;
    },
    hasSomeRenditionChanged() {
        return Object.keys(this.toJSON()).some(key => this.get(key).hasChanged());
    },
});
